import React, { useState } from 'react';
import LoadTimesStatistics from './LoadTimesStatistics';
import TagsStatistics from './TagsStatistics';
import DailyStats from './DailyStats';
import GclidDownloads from './GclidDownloads';
import ProspectsReport from './ProspectsReport';
import WordCloudStats from './WordCloudStats';

const Stats = () => {
  const [selectedOption, setSelectedOption] = useState('Load Times');

  const handleSelectOption = (option) => {
    setSelectedOption(option);
  };

  return (
    <div className="flex h-screen bg-gray-20">
      {/* Sidebar: Fixed to the left and scrollable */}
      <div className="sticky top-0 w-64 h-screen bg-gray-100 p-4 border-r overflow-y-auto">
        <h2 className="text-lg font-bold mb-4">Statistics</h2>
        <ul className="space-y-2">
          <li
            onClick={() => handleSelectOption('Load Times')}
            className={`cursor-pointer p-2 rounded-lg shadow transition ${
              selectedOption === 'Load Times'
                ? 'bg-[#4790CF] text-white'
                : 'bg-white hover:bg-gray-200 text-gray-800'
            }`}
          >
            Load Times
          </li>
          <li
            onClick={() => handleSelectOption('Tags')}
            className={`cursor-pointer p-2 rounded-lg shadow transition ${
              selectedOption === 'Tags'
                ? 'bg-[#4790CF] text-white'
                : 'bg-white hover:bg-gray-200 text-gray-800'
            }`}
          >
            Tags
          </li>
          <li
            onClick={() => handleSelectOption('Daily')}
            className={`cursor-pointer p-2 rounded-lg shadow transition ${
              selectedOption === 'Daily'
                ? 'bg-[#4790CF] text-white'
                : 'bg-white hover:bg-gray-200 text-gray-800'
            }`}
          >
            Daily Stats
          </li>
          <li
            onClick={() => handleSelectOption('Downloads')}
            className={`cursor-pointer p-2 rounded-lg shadow transition ${
              selectedOption === 'Downloads'
                ? 'bg-[#4790CF] text-white'
                : 'bg-white hover:bg-gray-200 text-gray-800'
            }`}
          >
            Gclid Downloads
          </li>
          <li
            onClick={() => handleSelectOption('WordCloudStats')}
            className={`cursor-pointer p-2 rounded-lg shadow transition ${
              selectedOption === 'WordCloudStats'
                ? 'bg-[#4790CF] text-white'
                : 'bg-white hover:bg-gray-200 text-gray-800'
            }`}
          >
            Análisis de Palabras  
          </li>
          <li
            onClick={() => handleSelectOption('Analisis')}
            className={`cursor-pointer p-2 rounded-lg shadow transition ${
              selectedOption === 'Analisis'
                ? 'bg-[#4790CF] text-white'
                : 'bg-white hover:bg-gray-200 text-gray-800'
            }`}
          >
            Reporte de Prospectos
          </li>
        </ul>
      </div>

      {/* Main Area */}
      <div className="flex-grow flex flex-col">
        <div className="flex-grow flex justify-center items-center p-6">
          <div className="w-full max-w-4xl h-full mt-20 flex flex-col items-center">
            {selectedOption === 'Load Times' && <LoadTimesStatistics />}
            {selectedOption === 'Tags' && <TagsStatistics />}
            {selectedOption === 'Daily' && <DailyStats />}
            {selectedOption === 'Downloads' && <GclidDownloads />}
            {selectedOption === 'WordCloudStats' && <WordCloudStats />}
            {selectedOption === 'Analisis' && <ProspectsReport />}
            {/* Add more sections as needed */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Stats;
